import { PreviewImageModal } from "components/Common/Portals/PreviewImageModal/PreviewImageModal";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { usePortal } from "./PortalContext";
import { useSmartRef } from "hooks/useSmartRef";
import { uid } from "lib/uid";
import { EMPTY_OBJECT } from "constants/defaults";

export const PreviewImageModalContext = createContext();

const initialUid = uid();

export const PreviewImageModalProvider = ({ children }) => {
  const portalProps = usePortal();
  const portalPropsRef = useSmartRef(portalProps);

  const [previewImageModalForceUpdate, setPreviewImageModalForceUpdate] =
    useState(initialUid);
  const [previewImageModalSrc, setPreviewImageModalSrc] = useState();
  const [previewImageModalSrcOptions, setPreviewImageModalSrcOptions] =
    useState(EMPTY_OBJECT);

  useEffect(() => {
    if (previewImageModalForceUpdate > initialUid) {
      portalPropsRef?.current?.setIsPortalComponentRendered(true);
    }
  }, [portalPropsRef, previewImageModalForceUpdate]);

  const openPreviewImageModal = useCallback((val, options = EMPTY_OBJECT) => {
    setPreviewImageModalForceUpdate(uid());
    setPreviewImageModalSrc(val);
    setPreviewImageModalSrcOptions(EMPTY_OBJECT);
  }, []);

  const value = useMemo(
    () => ({
      portalPropsRef,
      openPreviewImageModal,
    }),
    [openPreviewImageModal, portalPropsRef]
  );

  return (
    <PreviewImageModalContext.Provider value={value}>
      <PreviewImageModal
        portalProps={portalProps}
        value={previewImageModalSrc}
        title="Preview"
        {...previewImageModalSrcOptions}
      />
      {children}
    </PreviewImageModalContext.Provider>
  );
};

export const usePreviewImageModal = () => {
  return useContext(PreviewImageModalContext);
};
